import { object } from 'yup';

import { createValidator } from '@src/validation';
import { textValidator } from '@src/validation/textValidator';
import { controlApplicabilityStore } from '@stores/dictionaryStores/controlApplicabilityStore/controlApplicabilityStore';

const validateSchema = object().shape({
  orgCode: textValidator({ fieldName: 'orgCode' }),
  repGroupCode: textValidator({ fieldName: 'repGroupCode' }),
  ctrlVersCode: textValidator({ fieldName: 'ctrlVersCode' }).test(
    'ctrlVersCode',
    'Такая применимость контроля уже существует',
    (value, { parent: { id, orgCode, repGroupCode } }) => {
      const { controlApplicability } = controlApplicabilityStore;

      return !controlApplicability.some(
        (item) =>
          item.id !== id &&
          item.orgCode === orgCode &&
          item.repGroupCode === repGroupCode &&
          item.ctrlVersCode === value,
      );
    },
  ),
});

export const validate = createValidator(validateSchema);
